/* eslint-disable no-unused-vars */
import Vue from "vue";
import axios from "axios";
import { Form, Message } from "element-ui";
import qs from "qs";

let token = "";

axios.defaults.timeout = 5 * 1000;
let baseURL = "http://iotqcloud.com/LazySetup/desktop/";
// let baseURL = "http://192.168.0.105:8989/LazySetup/desktop/";
// let baseURL = "http://192.168.0.77:8383/LazySetup/desktop/";
// let baseURL = "/LazySetup/desktop/";
// 配置接口地址
axios.defaults.baseURL = baseURL;
// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    token = sessionStorage.getItem("token");
    if (token) {
      config.headers.common["Authorization"] = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res) => {
    if (res.status == 200) {
      console.log(res);
      if (res.data.code == 0) {
        return Promise.resolve(res.data);
      } else {
        Message.error(res.data.msg);
        return Promise.reject(res);
      }
    }
  },
  (error) => {
    console.log(error.response);
    Message.error("请求异常");
    return Promise.reject(error.response);
  }
);

export const get = (url, data) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: data,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const post = (url, data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const uploadImg = (file, call) => {
  let data = new FormData();
  data.append("imgPicture", file);
  return new Promise((resolve, reject) => {
    axios
      .post("uploadPictures", data, {
        onUploadProgress: (progress) => {
          call(progress);
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
